import axios from 'axios';

export const tutorialVideosService = {
    getTutorialVideosService: () => axios.get('/tutorial-videos', { auth: true }),

    createTutorialVideoService: (body) => axios.post('/tutorial-videos', body, { auth: true }),

    editTutorialVideoService: (id, body) => axios.patch(`/tutorial-videos/${id}`, body, { auth: true }),

    deleteTutorialVideoService: (id) => axios.delete(`/tutorial-videos/${id}`, { auth: true }),
};
